'use client'

import { PageStructure } from './components'

export default function Home() {
  return <PageStructure />
}
